import {updateClientService} from "../../services/Administrative/clientsService";
import {useState} from "react";

export const useUpdateClient = () => {

    const [updatingClient, setUpdatingClient] = useState(false);

    const updateClient = async (clientDto: {}) => {
        setUpdatingClient(true);
        try {
            return await updateClientService(clientDto);
        } catch (error:any) {
            throw error
        }
        finally {
            setTimeout(() => {setUpdatingClient(false);}, 600)
        }
    };

    return { updateClient, updatingClient };
};
